import { useQuery } from "react-query";
import { RQ_GET_REFERRAL } from "../constant/core";
import { getReferralCodeStatus } from "../service/backend";

function useGetReferralStatus(address, options) {
  const getReferralStatus = async () => {
    const res = await getReferralCodeStatus(address);
    return res;
  };

  return useQuery([RQ_GET_REFERRAL, address], getReferralStatus, {
    ...options,
    enabled: Boolean(address),
  });
}

export default useGetReferralStatus;
